import { Text } from '@chakra-ui/react';
import { BackofficeActivitiesOrderItem } from '@diamond/shared/types';
import { useValuationType } from '@diamond/sol-admin/features/product';

import { useActivityDetail } from '../../../hooks/use-activity-detail';
import { EditableColumnProps } from '../../../types/activity-column-types';

interface Props
  extends EditableColumnProps<
    BackofficeActivitiesOrderItem,
    string | null | undefined
  > {
  activitiesId: string;
  token?: string;
  refetch: () => void;
}

export function ValuationTypeColumn({
  info,
  selectedData,
  onUpdate,
  activitiesId,
  token,
  refetch,
}: Props) {
  const isSelected = selectedData.some(
    (row) => row.original.id === info.row.original.id
  );

  const { valuationTypeData } = useValuationType(
    info.row.original.product_id,
    { size: 50, page: 1 },
    { enabled: isSelected }
  );

  const { handlePatchData } = useActivityDetail({
    selectedData,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setSelectedData: () => {},
    refetch,
    activitiesId,
    token,
  });

  const emptyItem = {
    label: '',
    value: '',
  };

  const valuationTypeItems = valuationTypeData
    ? [
        emptyItem,
        ...valuationTypeData.data.map((value) => ({
          label: value.valuation_type,
          value: value.valuation_type,
        })),
      ]
    : [emptyItem];

  const handleEdit = (value: string) => {
    onUpdate(value, info.row.original.id);
    handlePatchData(
      { valuation_type: value },
      '',
      `${activitiesId}/item/${info.row.original.id}`
    );
  };

  if (isSelected) {
    return (
      <div className="px-1">
        {valuationTypeItems.length > 1 && (
          <select
            name="valuation_type"
            id="valuation_type"
            style={{ padding: '4px' }}
            onChange={(e) => handleEdit(e.target.value)}
            defaultValue={info.row.original.valuation_type ?? ''}
          >
            {valuationTypeItems.map((value, index) => {
              return (
                <option value={value.value} key={index}>
                  {value.label}
                </option>
              );
            })}
          </select>
        )}
      </div>
    );
  }

  return (
    <Text fontSize="sm" fontWeight="400" color="#373F41">
      {info.getValue() ?? '-'}
    </Text>
  );
}
